import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M12.919 6.407v3.305M12.939 2a6.608 6.608 0 0 0-6.61 6.61v2.085c0 .675-.278 1.687-.626 2.263l-1.26 2.104c-.775 1.3-.239 2.75 1.19 3.226a23.165 23.165 0 0 0 14.621 0 2.203 2.203 0 0 0 1.191-3.226l-1.26-2.104c-.348-.576-.626-1.598-.626-2.263V8.61C19.55 4.978 16.572 2 12.94 2Z"
    />
    <path
      stroke="#A5A5AA"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M16.224 18.695A3.317 3.317 0 0 1 12.92 22a3.311 3.311 0 0 1-2.333-.973 3.311 3.311 0 0 1-.972-2.332"
    />
    <rect
      width={0.546}
      height={25.659}
      x={21.647}
      y={3.373}
      fill="#A5A5AA"
      stroke="#A5A5AA"
      strokeWidth={0.546}
      rx={0.273}
      transform="rotate(48.229 21.647 3.373)"
    />
  </svg>
);
export default SvgMute;
